import {
    CREATE_TEAM_MASTER_FAILURE,
    CREATE_TEAM_MASTER_REQUEST,
    CREATE_TEAM_MASTER_SUCCESS,
    CREATE_USER_FORM_TEAM_MASTER,
    FETCH_SINGLE_TEAM_MASTER_FAILURE,
    FETCH_SINGLE_TEAM_MASTER_REQUEST,
    FETCH_SINGLE_TEAM_MASTER_SUCCESS,
    FETCH_TEAM_MASTER_FAILURE,
    FETCH_TEAM_MASTER_REQUEST,
    FETCH_TEAM_MASTER_SUCCESS,
    NAVIGATE_TEAM_DETAILS,
    NAVIGATE_TEAM_MASTER,
    TEAM_MASTER_USERFORM_RESET,
    UPDATE_TEAM_MASTER_FAILURE,
    UPDATE_TEAM_MASTER_REQUEST,
    UPDATE_TEAM_MASTER_SUCCESS,
    FETCH_TEAM_MASTER_COMPANY_LIST_REQUEST,
    FETCH_TEAM_MASTER_COMPANY_LIST_SUCCESS,
    FETCH_TEAM_MASTER_COMPANY_LIST_FAILURE,
    FETCH_TEAM_MASTER_TEAM_LEAD_REQUEST,
    FETCH_TEAM_MASTER_TEAM_LEAD_SUCCESS,
    FETCH_TEAM_MASTER_TEAM_LEAD_FAILURE,
    DELETE_TEAM_MASTER_REQUEST,
    DELETE_TEAM_MASTER_SUCCESS,
    DELETE_TEAM_MASTER_FAILURE
} from './teamMaster.actionsType';

export const TEAM_MASTER = 'teamMaster';

let initialState = {
    loading: false,
    teamMaster: [],
    userform: {},
    companyList: {},
    teamLeadList: [],
    selectedTeam: {},
    isTeamMaster: false,
    teamId: null,
    errorMessage: '',
    iperrorMessage: ''
};

export let teamMasterReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_TEAM_MASTER_REQUEST:
        case FETCH_TEAM_MASTER_COMPANY_LIST_REQUEST:
        case FETCH_TEAM_MASTER_TEAM_LEAD_REQUEST:
        case CREATE_TEAM_MASTER_REQUEST:
        case FETCH_SINGLE_TEAM_MASTER_REQUEST:
        case UPDATE_TEAM_MASTER_REQUEST:
        case DELETE_TEAM_MASTER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_TEAM_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                teamMaster: updatePayload
            };

        case FETCH_TEAM_MASTER_COMPANY_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                companyList: updatePayload
            };
        case FETCH_TEAM_MASTER_TEAM_LEAD_SUCCESS:
            return {
                ...state,
                loading: false,
                teamLeadList: updatePayload
            };
        case CREATE_TEAM_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {}
            };
        case FETCH_SINGLE_TEAM_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedTeam: updatePayload,
                userform: {
                    company: updatePayload.fldFKCompany,
                    teamName: updatePayload.fldTeamName,
                    teamLead: updatePayload.fldFKTeamLeader,
                    unit: updatePayload.fldFKUnit
                }
            };
        case UPDATE_TEAM_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedTeam: {},
                userform: {}
            };
        case DELETE_TEAM_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {},
                companyList: {},
                teamLeadList: [],
                selectedTeam: {}
            };
        case FETCH_TEAM_MASTER_FAILURE:
        case FETCH_TEAM_MASTER_COMPANY_LIST_FAILURE:
        case FETCH_TEAM_MASTER_TEAM_LEAD_FAILURE:
        case FETCH_SINGLE_TEAM_MASTER_FAILURE:
        case CREATE_TEAM_MASTER_FAILURE:
        case UPDATE_TEAM_MASTER_FAILURE:
        case DELETE_TEAM_MASTER_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_TEAM_MASTER:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case TEAM_MASTER_USERFORM_RESET:
            return {
                ...state,
                userform: {},
                selectedTeam: {}
            };
        case NAVIGATE_TEAM_DETAILS:
            return {
                ...state,
                isTeamMaster: true,
                teamId: updatePayload.teamId
            };
        case NAVIGATE_TEAM_MASTER:
            return {
                ...state,
                isTeamMaster: false
            };
        default:
            return state;
    }
};
